import React from "react";
import { Box, Card, CardContent, Chip, Typography } from "@mui/material";
import CategoriasCardSubcategoria from "../CategoriasCardSubcategoria";

interface Subcategoria {
  id: string;
  name: string;
  isDeleted: boolean;
}

interface Categoria {
  id: string;
  name: string;
  segment: string;
  subcategories: Subcategoria[];
}

interface Props {
  categoria: Categoria;
  isLoading: boolean;
  token: string;
  onSubcategoriaUpdated: () => void;
}

const CategoriasCardCategoria: React.FC<Props> = ({
  categoria,
  isLoading,
  token,
  onSubcategoriaUpdated,
}) => {
  const ativas = categoria.subcategories.filter((subcategoria) => !subcategoria.isDeleted);
  const excluidas = categoria.subcategories.filter((subcategoria) => subcategoria.isDeleted);

  return (
    <Card sx={{ boxShadow: 3, borderRadius: 2, minHeight: 280 }}>
      <CardContent>
        <Box display="flex" alignItems="center" justifyContent="space-between" gap={2}>
          <Typography variant="h6">{categoria.name}</Typography>
          <Chip label="Categoria fixa" color="primary" size="small" />
        </Box>

        <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>
          Subcategorias ativas ({ativas.length})
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
          {ativas.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              Nenhuma subcategoria cadastrada.
            </Typography>
          ) : (
            ativas.map((subcategoria) => (
              <CategoriasCardSubcategoria
                key={subcategoria.id}
                subcategoria={subcategoria}
                token={token}
                isLoading={isLoading}
                onChanged={onSubcategoriaUpdated}
              />
            ))
          )}
        </Box>

        {excluidas.length > 0 && (
          <>
            <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 3, mb: 1 }}>
              Excluídas ({excluidas.length})
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {excluidas.map((subcategoria) => (
                <CategoriasCardSubcategoria
                  key={subcategoria.id}
                  subcategoria={subcategoria}
                  token={token}
                  isLoading={isLoading}
                  onChanged={onSubcategoriaUpdated}
                />
              ))}
            </Box>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default CategoriasCardCategoria;
